import React from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar, NavItem, NavDropdown, Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { UserRoles, UserRelationshipTypes } from '../helper';
import './NavMenu.css';

export class NavMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false
        };
    }

    closeNavbarMenu = () => {
        this.setState({ expanded: false });
    }

    toggleNavbarMenu = () => {
        this.setState(prevState => ({ expanded: !prevState.expanded }));
    }

    render() {
        let isAdmin = this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SuperUser;
        let canSeeGroupReports = isAdmin
            || this.props.userRole === UserRoles.StaffUser
            || this.props.userRole === UserRoles.StaffAnalyticsManager
            || this.props.userRole === UserRoles.StaffManagement
            || this.props.userRelationshipType === UserRelationshipTypes.Affiliate
            || this.props.userRelationshipType === UserRelationshipTypes.GpoEnterprise
            || this.props.userRole === UserRoles.PathwayStaffAnalyticsManager;
        let canSeePathwayMappings = isAdmin
            || this.props.userRole === UserRoles.PathwayStaffAnalyticsManager;

        return (
            <Navbar expanded={this.state.expanded} onToggle={this.toggleNavbarMenu}>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to={'/'} onClick={this.closeNavbarMenu}>
                            <Image src='/logo.png' height="25" />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        { /*
                        <LinkContainer to={'/'} exact>
                            <NavItem>
                                Home
                             </NavItem>
                        </LinkContainer>
                        */ }
                        {this.props.isAuthenticated &&
                            <React.Fragment>
                                <LinkContainer to={'/hospitals'}>
                                    <NavItem onClick={this.closeNavbarMenu}>
                                        Hospital
                                    </NavItem>
                                </LinkContainer>
                                {canSeeGroupReports &&
                                    <LinkContainer to={'/groupreports'}>
                                        <NavItem onClick={this.closeNavbarMenu}>
                                            Group Report
                                        </NavItem>
                                    </LinkContainer>
                                }
                                {canSeePathwayMappings &&
                                    <LinkContainer to={'/Mappings/Mappings'}>
                                        <NavItem onClick={this.closeNavbarMenu}>
                                            Mappings
                                        </NavItem>
                                    </LinkContainer>
                                }
                                {isAdmin &&
                                    <NavDropdown title="Manage" id="dropdownManage">
                                        <LinkContainer to={'/Manage/Users'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Users</NavItem >
                                        </LinkContainer>

                                        { /* Important entities */}
                                        <div className='divider' style={{ margin: '4pt' }} />
                                        <LinkContainer to={'/ManageGroups/AffiliateGroups'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Affiliate Groups</NavItem>
                                        </LinkContainer>
                                        <LinkContainer to={'/ManageGroups/GpoGroups'}>
                                            <NavItem onClick={this.closeNavbarMenu}>GPO Groups</NavItem>
                                        </LinkContainer>

                                        <div className='divider' style={{ margin: '4pt' }} />
                                        <LinkContainer to={'/Manage/Affiliates'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Affiliates</NavItem>
                                        </LinkContainer>
                                        <LinkContainer to={'/Manage/CodeGroups'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Code Groups</NavItem>
                                        </LinkContainer>
                                        <LinkContainer to={'/Manage/RevenueCategories'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Revenue Categories</NavItem>
                                        </LinkContainer>
                                        <LinkContainer to={'/Manage/ServiceLevels'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Service Levels</NavItem>
                                        </LinkContainer>

                                        { /* Metadata / attributes --- DP: Make super user only? Should change rarely. */}
                                        <div className='divider' style={{ margin: '4pt' }} />
                                        <LinkContainer to={'/Manage/ContactRoles'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Contact Roles</NavItem>
                                        </LinkContainer>
                                        <LinkContainer to={'/Manage/Manufacturers'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Manufacturers</NavItem>
                                        </LinkContainer>
                                        <LinkContainer to={'/Manage/UnitsOfMeasure'}>
                                            <NavItem onClick={this.closeNavbarMenu}>Units of Measure</NavItem>
                                        </LinkContainer>
                                    </NavDropdown>
                                }
                                <LinkContainer to={'/logout'}>
                                    <NavItem onClick={this.closeNavbarMenu}>
                                        Logout
                                    </NavItem>
                                </LinkContainer>
                            </React.Fragment>
                        }
                        {!this.props.isAuthenticated &&
                            <LinkContainer to={'/login'}>
                                <NavItem onClick={this.closeNavbarMenu}>
                                    Login
                                </NavItem>
                            </LinkContainer>
                        }
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default withRouter(connect(state => state.login)(NavMenu));



// WEBPACK FOOTER //
// ./src/components/NavMenu.js